<!-- Экран трансляции на тестирование-->
<template>
    <div>
        <div v-if="loaded" class="white_container check_reserved_container">
            <h4>{{$t("lesson.LBL_TECH_VIDEOCALL_PREHEADER")}}</h4>
            <h2>{{$t("lesson.LBL_TECH_VIDEOCALL_HEADER")}}</h2>
            <p v-html="$t('lesson.LBL_TECH_VIDEOCALL_COUNTDONE_HELPER',{
            date:date_planned,
            time:time_planed
            })"></p>
            <div class="timer"></div>
            <Countdown :date="stringToDateTimePlaned" v-on:onTick="onTick"></Countdown>
            <div v-if="isSoonLesson" class="lesson-prepare-form">
                <a :href="tech.link" target="_blank" class="button with_icon">
                    <i class="icon-play-circle"></i>
                    <span>{{$t("lesson.BTN_START_TECH_TRANSLATION")}}</span>
                </a>
                <p class="start_container_text" v-html="$t('lesson.LBL_TECH_VIDEOCALL_HELPER')"></p>
            </div>
            <div v-else>
                <button class="button button_not_active">
                <span>{{$t("lesson.BTN_TECH_VIDEOCALL_SOON")}}</span>
                </button>
            </div>
        </div>
        <div v-if="loaded" class="white_container reserved_info">
            <p class="text" v-html="$t('lesson.LBL_TECH_VIDEOCALL_DESCRIPTION')"></p>
            <div class="wrapp_descriptions">
                <div class="description">
                    <img src="/images/icon.png" alt="">
                    <div class="description_text_wrap">
                        <span class="description_text_number">01</span>
                        <span class="description_text" v-html="$t('lesson.LBL_TECH_VIDEOCALL_DESCRIPTION_STEP1')"></span>
                    </div>
                </div>
                <div class="description">
                    <img src="/images/icon1.png" alt="">
                    <div class="description_text_wrap">
                        <span class="description_text_number">02</span>
                        <span class="description_text" v-html="$t('lesson.LBL_TECH_VIDEOCALL_DESCRIPTION_STEP2')"></span>
                    </div>
                </div>
                <div class="description">
                    <img src="/images/icon2.png" alt="">
                    <div class="description_text_wrap">
                        <span class="description_text_number">03</span>
                        <span class="description_text" v-html="$t('lesson.LBL_TECH_VIDEOCALL_DESCRIPTION_STEP3')"></span>
                    </div>
                </div>
                <div class="description">
                    <img src="/images/icon3.png" alt="">
                    <div class="description_text_wrap">
                        <span class="description_text_number">04</span>
                        <span class="description_text" v-html="$t('lesson.LBL_TECH_VIDEOCALL_DESCRIPTION_STEP4')"></span>
                    </div>
                </div>
            </div>
        </div>
        <WaitingTehBookingSuccessPopup
            :show="showWaitingTehBookingSuccessPopup"
            :datetime="trial.datetime"
            v-on:closeEvent="waitingTehBookingSuccessPopupCloseEvent">
        </WaitingTehBookingSuccessPopup>
        <WaitingTehBookingFailPopup
            :show="showWaitingTehBookingFailPopup"
            v-on:closeEvent="waitingTehBookingFailPopupCloseEvent">
        </WaitingTehBookingFailPopup>
        <WaitingTehBookingNoVisitPopup
            :show="showWaitingTehBookingNoVisitPopup"
            v-on:closeEvent="waitingTehBookingNoVisitPopupCloseEvent">
        </WaitingTehBookingNoVisitPopup>
    </div>
</template>

<script>
    import axios from 'axios'
    import env from '@/enviroment';
    import lStorage from '@/store/localStorage';
    import store from '@/store';
    import Countdown from '../../Countdown';
    import { dateConvert, dateConvertToNumber, isSoonDate } from '../../../../../utils/utils';
    import { mapGetters, mapActions } from 'vuex';
    import WaitingTehBookingSuccessPopup from './popups/WaitingTehBookingSuccessPopup';
    import WaitingTehBookingFailPopup from './popups/WaitingTehBookingFailPopup';
    import WaitingTehBookingNoVisitPopup from './popups/WaitingTehBookingNoVisitPopup';
    import {rest} from "@/utils/utils";

    export default {
        name: "WaitingTehBookingStep",
        components: {
            Countdown,
            WaitingTehBookingSuccessPopup,
            WaitingTehBookingFailPopup,
            WaitingTehBookingNoVisitPopup
        },
        data: function () {
            return {
                loaded: true,
                isSoonLesson: false,
                showWaitingTehBookingSuccessPopup: false,
                showWaitingTehBookingNoVisitPopup: false,
                showWaitingTehBookingFailPopup: false,
                lastupdate:null
            }
        },
        computed: {
            ...mapGetters({
                tech: 'trialBookingFlow/tech',
                trial: 'trialBookingFlow/trial',
            }),
            stringToDateTimePlaned() {
                return dateConvertToNumber(this.tech.datetime);
            },
            date_planned(){
                var d = new Date(this.tech.datetime);
                return d.getFullYear()+"-"+(d.getMonth()+1)+"-"+d.getDate();
            },
            time_planed(){
                var d = new Date(this.tech.datetime);
                return d.getHours()+":"+d.getMinutes();
            }
        },
        methods: {
            onTick(time) {
                if ((time - 10 * 60) <= 0) {
                    this.isSoonLesson = true;
                } else {
                    this.isSoonLesson = false;
                }

                if (!this.showWaitingTehBookingSuccessPopup ||
                !this.showWaitingTehBookingNoVisitPopup ||
                !this.showWaitingTehBookingFailPopup) {
                    if (time <= 0) {
                        this.startCheckingStatus();
                    }
                }
            },
            changeAnyDate() {
                store.commit('user/is_planned', 0);
            },
            waitingTehBookingSuccessPopupCloseEvent() {
                this.showWaitingTehBookingSuccessPopup = !this.showWaitingTehBookingSuccessPopup;
                store.commit('trialBookingFlow/currentStep','tech-check-passed');
            },
            waitingTehBookingFailPopupCloseEvent() {
                store.commit('loading/is', true);
                axios.post(env.URL + '/wp-json/sahapi/v1/lesson_failed', {},{
                headers: {
                    'Authorization': 'Bearer ' + lStorage.get('auth-token'),
                },
                })
                .then((response) => {
                    let data = response.data;
                    store.commit('loading/is', false);
                    this.showWaitingTehBookingFailPopup = !this.showWaitingTehBookingFailPopup;
                    store.commit('trialBookingFlow/currentStep', 'test-new');
                })
                .catch((error) => {
                    console.log('lesson_failed', error);
                    store.commit('loading/is', false);
                });
            },
            waitingTehBookingNoVisitPopupCloseEvent() {
                store.commit('loading/is', true);
                axios.post(env.URL + '/wp-json/sahapi/v1/lesson_failed', {},{
                headers: {
                    'Authorization': 'Bearer ' + lStorage.get('auth-token'),
                },
                })
                .then((response) => {
                    let data = response.data;
                    store.commit('loading/is', false);
                    this.showWaitingTehBookingNoVisitPopup = !this.showWaitingTehBookingNoVisitPopup;
                    store.commit('trialBookingFlow/currentStep', 'test-new');
                })
                .catch((error) => {
                    console.log('lesson_failed', error);
                    store.commit('loading/is', false);
                });
            },
            startCheckingStatus(){
                //Будем проверять каждую минуту (60 секунд)
                if(!this.lastupdate || (Math.floor(Date.now() / 1000) - this.lastupdate > 60)){
                    this.lastupdate = Math.floor(Date.now() / 1000);
                    
                    store.commit('loading/is',true);
                    rest.call("lesson_status",{
                        "lesson_id":null,
                        "type":"technical",
                    }).then((response)=>{
                        store.commit('loading/is',false);
                        this.lastupdate = Math.floor(Date.now() / 1000);

                        if(response.lesson){
                            this.showWaitingTehBookingSuccessPopup = response.lesson.status === 'ok';
                            this.showWaitingTehBookingNoVisitPopup = response.lesson.status === 'no-visit';
                            this.showWaitingTehBookingFailPopup = response.lesson.status === 'fail';
                        }
                    }).catch((error)=>{
                        store.commit('loading/is',false);
                    });
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .button {
        padding: 0.75rem 2.5rem 1rem 2.5rem;
    }
    .button_not_active{
        background: #F0F3F8;
        span{
        color: #0B1022;
        }
        box-shadow: inherit !important;
        cursor: auto;
    }

    .lesson-prepare-form{
        display:flex;
        flex-direction:column;
        align-items:center;
        justify-content:center;
        padding: 6rem 0px 0px;
        text-align: center;
        p{
        margin-top:3rem;
        }
    }

    .timer {
        margin-top: 4.8rem;
    }

    .check_reserved_container {
        text-align: center;
        padding: 3rem 1.5rem 7rem;
    }

    .reserved_info {
        padding: 2.3rem 3.3rem;
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        margin-bottom: 2.3rem;
        margin-top: 2.3rem;

        .wrapp_descriptions {
        display: flex;
        flex-wrap: wrap;
        margin-top: 1.6rem;

            .description {
                display: flex;
                align-items: center;
                width: 50%;
                margin-top: 1.6rem;
                padding-right: 1rem;

                img {
                    width: 80px;
                    height: auto;
                    background: #E9ECF1;
                    border-radius: 100rem;
                    margin-right: 2.4rem;
                }

                .description_text_wrap {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;

                    .description_text_number {
                        font-family: FuturaPT;
                        font-size: 16px;
                        line-height: 20px;
                        letter-spacing: 0.5px;
                        color: rgba(11, 16, 34, 0.3);
                    }

                    .description_text {
                        font-family: FuturaPT;
                        font-size: 16px;
                        line-height: 20px;
                        letter-spacing: 0.5px;
                        color: #0B1022;
                    }
                }
            }
        }
    }
</style>